﻿import { ISystemsCountWidgetProps } from "./SystemsCountWidget.tsx";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider.tsx";
import { useState } from "react";
import { NavigationMenuItem } from "../../navigationMenuSettings/NavigationMenuSettings.types";
import { isNavigationMenuItemHidden } from "../../navigationMenuSettings/navigationMenuItems";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useSystemsCount(props: ISystemsCountWidgetProps) {
    const userContext = useUserContext();
    const isEnabled =
        userContext.permissions.systemPermissions.read && !isNavigationMenuItemHidden(userContext.hiddenNavigationMenuItems, NavigationMenuItem.Systems);

    const url = `/system/dashboard/systemsCount?onlyUserSpecific=${props.onlyUserSpecific}`;
    const { isLoading, data } = useDotLegalQuery<number>(url, {
        enabled: isEnabled,
    });

    return {
        isLoading,
        data,
        isEnabled,
    };
}
